<app-loading *ngIf="isLoading"></app-loading>
<div class="detail-container BMIQuestionnaire">
  <div class="row title-content">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <label>{{ "claimOffice.bmiAndQuestionnaire.title" | translate }}</label>
    </div>
  </div>
  <hr class="line" />

  <div class="row sub-title-content">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <label>{{ "claimOffice.bmiAndQuestionnaire.bmi" | translate }}</label>
    </div>
  </div>

  <div class="row bmiDetails">
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 subTitle">
          <p>{{ "claimOffice.bmiAndQuestionnaire.weight" | translate }}</p>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 subContent">
          {{BMIAndQuestionnaireInfo?.weight}}
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 subTitle">
          <p>{{ "claimOffice.bmiAndQuestionnaire.bmiCategory" | translate }}</p>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 subContent">
          {{BMIAndQuestionnaireInfo?.bmiCategory}}
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 subTitle">
          <p>{{ "claimOffice.bmiAndQuestionnaire.height" | translate }}</p>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 subContent">
          {{BMIAndQuestionnaireInfo?.height}}
          {{ "claimOffice.bmiAndQuestionnaire.cm" | translate }}
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 subTitle">
          <p>
            {{ "claimOffice.bmiAndQuestionnaire.bodyMassIndex" | translate }}
          </p>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 subContent">
          {{BMIAndQuestionnaireInfo?.bmi}}
        </div>
      </div>
    </div>
  </div>

  <div class="row sub-title-content mt-5 pt-2">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <label>{{
        "claimOffice.bmiAndQuestionnaire.applicationQuestionnaire.title"
          | translate
      }}</label>
    </div>
  </div>

  <div class="applicationAlign">
    <ng-container *ngFor="let item of BMIAndQuestionnaireInfo.questionList; index as i">
      <div class="row">
        <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 question">
          <p>
            {{item?.question}}
          </p>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 question-value">
          <p [ngClass]="{'yesQues': item?.answer === 'Y', 'noQues' : item.answer === 'N' }"
          class="yesQues">
            {{item?.answerDesc}}
          </p>
        </div>
      </div>
      <hr class="separateLine" *ngIf="i+1 !== BMIAndQuestionnaireInfo?.questionList.length"/>
    </ng-container>
  </div>
</div>
